// Tables
export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_RECORDINGS_TABLE = "recordings";
